import { Component, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { MatSort, MatTableDataSource } from '@angular/material';
import { TranslatePipe } from '@ngx-translate/core';
import * as moment from 'moment';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { BaseComponent } from 'src/app/_base/base.component';
import { ActionTypes, NotesStudents, StudentNoteModel, StudentsNotes } from 'src/app/_models';
import { NotesService } from 'src/app/_services/notes/notes-service';

@Component({
  selector: 'app-student-notes-details',
  templateUrl: './student-notes-details.component.html',
  styleUrls: ['./student-notes-details.component.scss'],
  providers: [TranslatePipe]
})
export class StudentNotesDetailsComponent extends BaseComponent implements OnInit {
  @Input()
  students: StudentsNotes[] = [];
  @Input()
  student: StudentsNotes = null;
  @Input()
  studentNoteModel: StudentNoteModel = new StudentNoteModel();
  @Input()
  date: any;
  notes: NotesStudents[] = [];
  @ViewChild(MatSort) sort: MatSort;
  labels: string[] = [];
  backgroundColors: string[] = [];
  chartData: number[] = [];
  redrew: boolean = true;
  actionTypes = ActionTypes;
  configurations: PerfectScrollbarConfigInterface = {
    suppressScrollX: false,
    suppressScrollY: true
  };

  displayedColumns: string[] = ['i', 'noteDate', 'noteMessage', 'subjectName', 'noteTypeId', 'actions'];
  dataToBindSource = new MatTableDataSource<NotesStudents>();
  isOpenedDelete: boolean = false;
  constructor(private modalRef: BsModalRef, private translatePipe: TranslatePipe, public notesService: NotesService) {
    super();
  }

  ngOnInit() {
    if (this.translateService.currentLang === 'en') this.displayedColumns[3] = 'subjectNameEn';
    this.backgroundColors = ['#fd7e14', '#86c27c'];
    this.labels = [
      this.translatePipe.transform('AcademicModule.notesModule.public'),
      this.translatePipe.transform('AcademicModule.notesModule.private')
    ];
    this.studentNotesInit();
  }
  studentNotesInit(): void {
    this.getStudentNotes();
  }
  tableInit(): void {
    if (this.translateService.currentLang === 'en') this.displayedColumns[3] = 'subjectNameEn';
    else this.displayedColumns[3] = 'subjectName';
  }
  getStudentNotes(): void {
    BaseComponent.spinner.isActive = true;
    this.notesService
      .GetNoteForStudent(
        this.student.studentId,
        this.studentNoteModel.sectionSubjectId,
        this.studentNoteModel.startDate,
        this.studentNoteModel.endDate
      )
      .subscribe(
        (data: NotesStudents[]) => {
          this.notes = data;
          this.studentNoteModel.className = data[0].className;
          this.studentNoteModel.classNameEn = data[0].classNameEn;
          this.studentNoteModel.sectionName = data[0].sectionName;
          this.studentNoteModel.sectionNameEn = data[0].sectionNameEn;
          this.studentNotesTableInit();
          this.pieChartInit();
          BaseComponent.spinner.isActive = false;
        },
        () => {
          BaseComponent.spinner.isActive = false;
        }
      );
  }
  studentNotesTableInit(): void {
    if (this.date) {
      this.dataToBindSource.data = this.notes.filter(f => moment(f.noteDate).isSameOrBefore(moment(this.date)));
    } else {
      this.dataToBindSource.data = this.notes.filter(f => f.noteDate);
    }

    setTimeout(() => {
      this.dataToBindSource.sort = this.sort;
    }, 50);
  }

  pieChartInit(): void {
    let publicNumber: number = 0;
    let privateNumber: number = 0;
    this.notes.map(item => {
      item.noteTypeId === this.actionTypes.public ? (publicNumber += 1) : (privateNumber += 1);
    });
    this.chartData = [publicNumber, privateNumber];
    this.resize();
  }

  modalClose(): void {
    this.modalRef.hide();
  }

  getPrevious(): void {
    const currentStudentIndex: number = this.students.findIndex(item => item.studentId === this.student.studentId);
    if (currentStudentIndex !== -1)
      if (currentStudentIndex - 1 >= 0) {
        this.student = this.students[currentStudentIndex - 1];
        this.studentNotesInit();
      } else {
        this.student = this.students[this.students.length - 1];
        this.studentNotesInit();
      }
  }

  getNext(): void {
    const currentStudentIndex: number = this.students.findIndex(item => item.studentId === this.student.studentId);
    if (currentStudentIndex !== -1)
      if (currentStudentIndex + 1 <= this.students.length - 1) {
        this.student = this.students[currentStudentIndex + 1];
        this.studentNotesInit();
      } else {
        this.student = this.students[0];
        this.studentNotesInit();
      }
  }

  @HostListener('window:resize', ['$event'])
  resize() {
    this.redrew = false;
    setTimeout(() => {
      this.redrew = true;
    }, 100);
  }
  removeNote(noteId: number) {
    this.isOpenedDelete = true;
    const callback = () => {
      this.isOpenedDelete = false;
      BaseComponent.spinner.isActive = true;
      this.notesService.RemoveStudentNote(this.student.studentId, noteId).subscribe(
        () => {
          this.studentNotesInit();
          BaseComponent.spinner.isActive = false;
          this.showSuccess('AcademicModule.notesModule.StudentNoteDeletedSuccessfully');
        },
        () => {
          BaseComponent.spinner.isActive = false;
          this.showError('AcademicModule.notesModule.ErrorWhileDeletingStudentNote');
        }
      );
    };
    this.showConfirmYesNoMessage(
      'AcademicModule.notesModule.AreYouSureYouWantToDeleteNoteFromThisStudent?',
      'AcademicModule.notesModule.DeleteStudentNote',
      callback,
      () => (this.isOpenedDelete = false)
    );
  }
}
